import template from './app.html';
import controller from './app.controller';
import './app.styl';

const AppComponent = {
  template,
  controller,
  controllerAs: 'app'
};

export default AppComponent;


/** WEBPACK FOOTER **
 ** ./frontend/app.component.js
 **/